import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import styles from "./EventImagesSection.module.scss";
import { useTranslation } from "../../i18n";

interface EventImage {
  id: string | number;
  public_link: string;
}

interface EventImagesSectionProps {
  eventImages: EventImage[];
  onRemoveImage: (imageId: string | number) => void;
  onOpenGallery: () => void;
}

export const EventImagesSection = ({
  eventImages,
  onRemoveImage,
  onOpenGallery,
}: EventImagesSectionProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p style={{ margin: "8px 0" }}>{t("images.eventPhotos")}</p>
      </div>
      <div className={styles.eventImagesPreview}>
        {eventImages?.length > 0 &&
          eventImages.map((image) => {
            return (
              <div className={styles.previewImageWrapper} key={image.id}>
                <IconButton
                  onClick={() => onRemoveImage(image.id)}
                  className={styles.deleteButtonSmall}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
                <img
                  src={image.public_link}
                  alt={t("gallery.imageAlt", { id: String(image.id) })}
                  width="80px"
                  height="80px"
                  className={styles.previewImage}
                />
              </div>
            );
          })}
        <div className={styles.addImageTileSmall} onClick={onOpenGallery}>
          <AddIcon sx={{ fontSize: 32, color: "#8a2be2" }} />
          <span>{t("images.manage")}</span>
        </div>
      </div>
    </div>
  );
};
